import { render, staticRenderFns } from "./CompanySupervisionPercentConfig.vue?vue&type=template&id=2fa38696&scoped=true&"
import script from "./CompanySupervisionPercentConfig.vue?vue&type=script&lang=js&"
export * from "./CompanySupervisionPercentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa38696",
  null
  
)

export default component.exports